import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=21a27947&lang=pug&"
import script from "./Video.vue?vue&type=script&lang=js&"
export * from "./Video.vue?vue&type=script&lang=js&"
import style0 from "./Video.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21a27947')) {
      api.createRecord('21a27947', component.options)
    } else {
      api.reload('21a27947', component.options)
    }
    module.hot.accept("./Video.vue?vue&type=template&id=21a27947&lang=pug&", function () {
      api.rerender('21a27947', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/Video.vue"
export default component.exports